import Application from 'src/Application';
import uiConfig from 'src/lib/ui/config';
import { ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';

export default class ToiletRoomScene extends ResponsiveScene {
  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.toiletRoom,
      }),
    );

    this.getView().tag = 'toilet';

    this.addToiletAsset();
  }

  private addToiletAsset() {
    const scene = this.getView();
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.toiletRoomToilet));
  }

  public transition(): Transition {
    return 'slide_forward';
  }
}
